import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faGooglePlay, faAppStore } from "@fortawesome/free-brands-svg-icons";
import React from "react";

import styles from "./AppItem.module.scss";

const AppItem = ({ app }) => (
	<div className={styles.appItem}>
		<img className={styles.appItem__icon} src={app.icon} alt={app.name} />
		<div className={styles.appItem__details}>
			<div className={styles.appItem__name}>{app.name}</div>
			<div className={styles.appItem__category}>{app.category}</div>
			<div className={styles.appItem__rating}>
				{app.rating} <FontAwesomeIcon icon={faStar} color="orange" />
			</div>
		</div>
		<FontAwesomeIcon
			className={styles.appItem__platformIcon}
			icon={app.platform === "playStore" ? faGooglePlay : faAppStore}
			style={{ color: app.platform === "playStore" ? "green" : "" }}
			size="lg"
		/>
	</div>
);

export default AppItem;
